export default {
  methods: {
    /**
     *  Track an event in all the specified metric tracking system
     *
     *  @param event {String} Name of the event to track
     *  @param category {String} Category of the event
     *  @param label {String} Extra information of the event to track
     *  @return {Boolean} Boolean with the tracking result
     */
    $track(event, category, label) {
      if (!event) {
        return false;
      }

      const details = {};

      if (typeof category === 'string') {
        details.event_category = category;
      }
      if (typeof label === 'string') {
        details.event_label = label;
      }

      this.$gtag.event(event, details);

      // If we're in a compiled app, fallback into GA3 events
      if (process.env.VUE_APP_BUILD_TARGET === 'app') {
        window.ga('send', 'event', category, event, label);
      }

      return true;
    },
  },
};
